export enum RequestAReviewTab {
  RequestForm = 0,
  ListOfReviewers = 1,
}
